import { render, staticRenderFns } from "./BookingIndex.vue?vue&type=template&id=ede99776&"
import script from "./BookingIndex.vue?vue&type=script&lang=js&"
export * from "./BookingIndex.vue?vue&type=script&lang=js&"
import style0 from "./BookingIndex.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports